import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useTranslation } from '../useTranslation';

const Gallery = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = "terroir";

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { data, error } = await supabase
          .from("category_images")
          .select("*")
          .eq("category", category);

        if (!error) {
          setImages(data || []);
        } else {
          console.error("Erreur de chargement des images :", error.message);
        }
      } catch (err) {
        console.error("Erreur de chargement des images :", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <section id="gallery" className="gallery">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>{t('OilMilGalleryTitle')}</h2>
<p>{t('OilMilGallerySubtitle')}</p>
        </div>
      </div>

      <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
        {loading ? (
<p className="text-center">{t('loadingImages')}</p>
        ) : images.length === 0 ? (
<p className="text-center">{t('noCategoryImages')}</p>
        ) : (
          <div className="row g-0">
            {images.map((image) => (
              <div className="col-lg-3 col-md-4" key={image.id}>
                <div className="gallery-item">
                  <a
                    href={image.url}
                    className="gallery-lightbox"
                    data-gall="gallery-item"
                  >
                    <img
                      src={image.url}
                      alt={`Image de la catégorie ${category}`}
                      className="img-fluid gallery-image"
                      style={{
                        width: '100%',
                        height: '300px',
                        objectFit: 'cover',
                        objectPosition: 'center'
                      }}
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;